import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { CreateInformationForm } from "@/features/informations";
import { HeadTitle } from "@/shared";
import { useSnackbar } from "@/shared/hooks";

export default function NewInformationPage() {
	const location = useLocation();
	const initialData = location.state?.initialData;
	const { showSuccess, showError } = useSnackbar();

	const handleSuccess = (message?: string) => {
		showSuccess(message || "お知らせを配信しました");
	};

	const handleError = (message: string) => {
		showError(message || "配信に失敗しました");
	};

	return (
		<Box
			sx={{
				m: 2,
				height: "100%",
				width: "100%",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<HeadTitle pageTitle={"お知らせ新規作成"} />

			<Typography component="h2" variant="h6" sx={{ fontWeight: "bold", mb: 3 }}>
				お知らせ新規作成
			</Typography>

			<CreateInformationForm
				initialData={initialData}
				onSuccess={handleSuccess}
				onError={handleError}
			/>
		</Box>
	);
}
